module.exports = __webpack_public_path__ + "img/pr-5.e400bf79.png";